import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { Home } from '../Pages/Home'
import {Dashboard} from "../Pages/Dashboard"
import { About } from '../Pages/About'
import Inbox from '../components/Inbox'

const Allroutes = () => {
  return (
    <Routes>
        <Route path="/"  element={<Home/>} />
        <Route path="/dashboard"  element={<Dashboard/>} />
        <Route path="/about"  element={<About/>} />
        <Route path="/dashboard/inbox"  element={<Inbox/>} />

    </Routes>
  )
}

export default Allroutes